import React, { useEffect, useState } from "react";
import Breadcrumb from "./Breadcrumb";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import { Tab, Nav } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { IncomingInvoiceService } from "../../../services/incoming-invoice-service";
import IncomingInvoiceItems from "./Incominginvoiceitems";
import { ToastContainer } from "react-toastify";
import IncomingInvoicelist from "./Incominginvoicelist";

export const Content = (props) => {
  const { grnID } = useParams();

  useEffect(() => {
    IncomingInvoiceDetailSearchID();
  }, []);

  const [incomingInvoiceInfo, setIncomingInvoiceInfo] = useState({
    supplier_name: "",
    invoice_number: "",
    total_price: "",
    comment: "",
    received_date: "",
    status: "",
  });

  const [incomingInvoiceItemsinfo, setIncomingInvoiceItemsinfo] = useState([]);

  const IncomingInvoiceDetailSearchID = async () => {
    try {
      const result = await IncomingInvoiceService.incomingInvoiceDetailsID(grnID);
      const info = {};

      const invoicedata = result;

      info.supplier_name = invoicedata.publisher.name;
      info.invoice_number = invoicedata.invoice_number;
      info.total_price = invoicedata.total_price;
      info.comment = invoicedata.comment;
      info.received_date = invoicedata.received_date;
      info.status = invoicedata.status;

      setIncomingInvoiceInfo(info);
      setIncomingInvoiceItemsinfo(invoicedata.invoiceItems);
      
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb />
        </div>
        <div className="col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Edit Goods Received Note(GRN)</h6>
            </div>
            <div className="ms-panel-body clearfix">
              <Tab.Container defaultActiveKey="tab13">
                <Nav
                  variant="tabs"
                  className="nav nav-tabs d-flex nav-justified mb-4"
                >
                  <Nav.Item>
                    <Nav.Link eventKey="tab13">Goods Received Note(GRN)</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="tab14">Goods Received Note(GRN) List</Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="tab13">
                    <IncomingInvoicelist
                      supplier_name={incomingInvoiceInfo.supplier_name}
                      invoice_number={incomingInvoiceInfo.invoice_number}
                      total_price={incomingInvoiceInfo.total_price}
                      comment={incomingInvoiceInfo.comment}
                      received_date={incomingInvoiceInfo.received_date}
                      status={incomingInvoiceInfo.status}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="tab14">
                    <IncomingInvoiceItems incomingInvoiceItemsInfo={incomingInvoiceItemsinfo} />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
